import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { GetAllRecitalsResponse } from '../model/recital';

export interface GetAllRecitalsParams {
  page?: number;
  limit?: number;
  status?: 'draft' | 'published' | 'archived';
  year?: number;
}

export const getAllRecitalsAPI = async (params?: GetAllRecitalsParams) => {
  const response = await baseAPI.get<GetAllRecitalsResponse>('/recitals', {
    params,
  });
  return response.data;
};

export const getAllRecitalsOptions = (params?: GetAllRecitalsParams) => {
  return queryOptions({
    queryKey: QUERY_KEYS.RECITALS(params),
    queryFn: () => getAllRecitalsAPI(params),
    staleTime: 1000 * 60 * 5,
  });
};

export const useGetAllRecitals = (params?: GetAllRecitalsParams) => {
  return useQuery(getAllRecitalsOptions(params));
};
